/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/
export enum ReloadAction{
  SET_RELOAD = 'SET_RELOAD',
  GET_RELOAD = 'GET_RELOAD',
}
